module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "sWeb",
    staticClass: "s-web"
  }, [_c('k-header', {
    attrs: {
      "headerData": _vm.headerTeacher
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "darg-wrap"
  }, [_c('drag', [_c('div', {
    staticClass: "work",
    attrs: {
      "slot": "uLeft"
    },
    slot: "uLeft"
  }, [_c('code-editor')], 1), _vm._v(" "), _c('div', {
    staticClass: "work",
    attrs: {
      "slot": "dLeft"
    },
    slot: "dLeft"
  }, [_c('h1', [_vm._v("下左侧")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("获取代码")])]), _vm._v(" "), _c('div', {
    staticClass: "work",
    attrs: {
      "slot": "uRight"
    },
    slot: "uRight"
  }, [_c('h1', [_vm._v("上右侧")])]), _vm._v(" "), _c('div', {
    staticClass: "work",
    attrs: {
      "slot": "dRight"
    },
    slot: "dRight"
  }, [_c('h1', [_vm._v("下右侧")])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-860590da","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/chat/drag.vue
// module id = 523
// module chunks = 1